import { ApplicationErrorPage } from "Infrastructure/Pages/ApplicationErrorPage";
import { LoadingMessage } from "Shared/LoadingMessage";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Outlet } from "react-router";

/**
 * Bare frame for the public client-share routes. Deliberately omits every piece
 * of authenticated app chrome (topbar, sidebar, client switcher) and the auth
 * gate — anonymous visitors must reach it without a token. Each public page
 * renders its own tenant-branded header from the share payload.
 */
export const PublicLayout = () => (
	<ErrorBoundary FallbackComponent={ApplicationErrorPage}>
		<div className="bg-background text-foreground flex min-h-screen w-full flex-col font-sans">
			<Suspense
				fallback={
					<div className="flex flex-1 items-center justify-center">
						<LoadingMessage />
					</div>
				}
			>
				<Outlet />
			</Suspense>
		</div>
	</ErrorBoundary>
);
